export default "__VITE_ASSET__Cdm7h2wb__"